import { ContactUsFacadeService } from './../../_app_modules/contact-us/desktop-contact-us/contact-us-facade.service';
import { PlatformLimitedAccessType, UserSettingsService } from '@feature/user-settings';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, combineLatest } from 'rxjs';
import { Navigation, NavigableWidgetConfigItem } from 'app/core/navigation/navigation.types';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { NavProviderService } from '@feature/core/navigation/nav-provider.service';

@Injectable(
    {
        providedIn: 'root'
    })
export class MftNavigationProviderService extends NavProviderService {

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient,
    private UrlBuilderService: UrlBuilderService, private userSettingsService: UserSettingsService,  private contactUsFacadeService: ContactUsFacadeService) {
    super();
  }

  override get(): Observable<Navigation> {

    const joined = combineLatest([this.userSettingsService.getUserSettings(), this._httpClient.get<NavigableWidgetConfigItem[]>(this.UrlBuilderService.getUrl('mft/navigation'))]);
    return joined.pipe(
      map(([userSettings, widgetConfigs]) => {
        const homeMenuItem: FuseNavigationItem = {
          id: 'home',
          pageHeader: 'Home',
          title: 'Home',
          type: 'basic',
          link: '/m/mft',
          exactMatch: true
        };

        const navItems = [homeMenuItem];
        navItems.push(...this.mapConfigsToNavItemsByWidgetTypeName(widgetConfigs, 'NoticeBoard'));
        navItems.push(...this.mapConfigsToNavItemsByWidgetTypeName(widgetConfigs, 'DebtBalancesDueWidget'));
        navItems.push(...this.mapConfigsToNavItemsByWidgetTypeName(widgetConfigs, 'ItemsDueWidget'));
        navItems.push(...this.mapConfigsToNavItemsByWidgetTypeName(widgetConfigs, 'InvoicesAndReceiptsWidget'));
        navItems.push(...this.mapConfigsToNavItemsByName(widgetConfigs, 'Details'));
        navItems.push(...this.mapConfigsToNavItemsByWidgetTypeName(widgetConfigs, 'MftDocumentCentre'));

        if (userSettings.FaqEnabled) {
          const faq: FuseNavigationItem = {
            id: 'faq',
            title: 'FAQ',
            type: 'basic',
            link: '/m/mft/faq',
            exactMatch: true
          };
          navItems.push(faq);
        }

        const contactUs: FuseNavigationItem = {
          id: 'contactUs',
          title: 'Contact us',
          type: 'basic',
          function: () => this.contactUsFacadeService.load()
        };
        navItems.push(contactUs);

        const aboutMenuItem: FuseNavigationItem = {
          id: 'about',
          pageHeader: 'About',
          title: 'About',
          type: 'basic',
          link: '/m/mft/about',
          exactMatch: true
        };
        navItems.push(aboutMenuItem);

        return {
          compact: navItems,
          default: navItems,
          futuristic: navItems,
          horizontal: navItems
        };
      })
    );
  }

  /**
    * Creates a `FuseNavigationItem` based upon a `NavigableWidgetConfigItem`.
    * @param config a navigable widget config.
    * @returns A FUSE navigation item.
    */
  mapConfigToNavItem = (config: NavigableWidgetConfigItem): FuseNavigationItem => {
  
    if (config.Children) {
      return {
        title: config.Title,
        type: 'collapsable',
        children: config.Children.map(this.mapConfigToNavItem)
      };
    }
    return {
      id: config.WidgetConfigId,
      pageHeader: config.Title,
      title: config.Name,
      type: 'basic',
      link: this.getRouteFromConfig(config)
    };
  }

  mapConfigsToNavItemsByName = (configs: NavigableWidgetConfigItem[], name: string): FuseNavigationItem[] =>{
    return configs.filter(x => x.Name == name).map(this.mapConfigToNavItem);
  }
  
  mapConfigsToNavItemsByWidgetTypeName = (configs: NavigableWidgetConfigItem[], widgetType: string): FuseNavigationItem[] =>{
    return configs.filter(x => x.WidgetType == widgetType).map(this.mapConfigToNavItem);
  }

  getRouteFromConfig(config: NavigableWidgetConfigItem): string {

      /** 
        * @todo 
        * - The route naming convention looks wonky (mixed case)
        * - and we derive these routes instead of making a switch statement?
        * - why is the default an empty route? what is the intention there?
        */

        switch (config.WidgetType) {
          case 'MftDocumentCentre':
            return `/m/mft/document-centre/${config.WidgetConfigId}`;
          case 'ItemsDueWidget':
              return `/m/mft/items-due/${config.WidgetConfigId}`;
          case 'InvoicesAndReceiptsWidget':
              return `/m/mft/invoices-and-receipts/${config.WidgetConfigId}`;
          case 'NoticeBoard':
              return `/m/mft/notice-board/${config.WidgetConfigId}`;
          case 'MftLeaseDetailsWidget':
            return `/m/mft/details/Lease/${config.WidgetConfigId}/Lease`;        
          case 'MftUnitDetailsWidget':
            return `/m/mft/details/MftUnit/${config.WidgetConfigId}/Unit`;
          case 'MftTenantParentDetailsWidget':
            return `/m/mft/details/MftTenantParent/${config.WidgetConfigId}/TenantParent`;
          case 'MftTenantDetailsWidget':
            return `/m/mft/details/MftTenant/${config.WidgetConfigId}/Tenant`;
          case 'MftDebtorDetailsWidget':
            return `/m/mft/details/MftDebtor/${config.WidgetConfigId}/Debtor`;
          case 'DebtBalancesDueWidget':
            return `/m/mft/debt-balances-due/${config.WidgetConfigId}`;
          default:
            return '';
        }
    }
}